export enum remittanceDialogSteps {
  chooseOption = 0,
  remittanceDetails,
  pickDate,
  uploadFileSubmit,
  submitRequest,
  other,
}

export function getStepHeader(step: remittanceDialogSteps) {
  switch (step) {
    case remittanceDialogSteps.remittanceDetails:
      return `Modify a Remittance`;
    case remittanceDialogSteps.pickDate:
      return `Reschedule Remittance`;
    case remittanceDialogSteps.uploadFileSubmit:
      return `You’re about to submit a request
to change the date of a scheduled Remittance.`;
    case remittanceDialogSteps.submitRequest:
      return `We’re on it.`;
  }
}

export function getStepDescription(step: remittanceDialogSteps) {
  switch (step) {
    case remittanceDialogSteps.remittanceDetails:
      return `This request is intended for a one-time rescheduling (up to two weeks) of a remittance due to a short term cash crunch. 

        If you need to request a significant modification to your remittance schedule due to a change in your supply chain or pace of sales, that should be submitted via Lines.`;
    case remittanceDialogSteps.pickDate:
      return `What date would you like to move this Remittance to?`;
    case remittanceDialogSteps.uploadFileSubmit:
      return `Our flexible Growth Plans adjust to your business,
        not the other way around.`;
    case remittanceDialogSteps.submitRequest:
      return `Hang tight while a member of our team reviews your request. 
        You should receive a response within 72 hours.`;
  }
}

export function getOtherHeader(step: remittanceDialogSteps) {
  switch (step) {
    case remittanceDialogSteps.chooseOption:
      return `What would you like to change?`;
    case remittanceDialogSteps.other:
      return `Please Submit a Change via Lines`;
  }
}

export function getOtherDescription(step: remittanceDialogSteps) {
  switch (step) {
    case remittanceDialogSteps.chooseOption:
      return `Select the first change you’d like to make. 
      You’ll be able to select more changes later.`;
    case remittanceDialogSteps.other:
      return `If there has been a material change to your supply chain then moving a single remittance won’t solve what will likely be a prolonged cash flow issue. Instead, you’ll need to submit a change request via Lines which will allow our team to adjust your remittance schedule as needed.`;
  }
}
